import { Link } from 'react-router-dom';
import Styles from '../../styles/report/reportbutton.module.scss';

const Reportbutton = ({
  totalPages = 2,
  basePath = '/fitnes-report-preview-detailed',
  showNext = true,
  clientId,
}) => {
  // Get current path to determine active page
  const currentPath = window.location.pathname;
  console.log("clientId",clientId);
  
  
  // Determine current page based on URL
  const getCurrentPageNumber = () => {
    if (currentPath === `/fitnes-report-preview-summary/${clientId}`) {
      return 1;
    } else if (currentPath === `/fitnes-report-preview-detailed/${clientId}`) {
      return 2;
    }
    // For additional pages, you can add more logic here
    return 1;
  };
  
  const currentPage = getCurrentPageNumber();

  // Custom navigation logic
  const getPagePath = (pageNumber) => {
    if (pageNumber === 1) {
      return `/fitnes-report-preview-summary/${clientId}`;
    } else if (pageNumber === 2) {
      return `/fitnes-report-preview-detailed/${clientId}`;
    }
    // For any additional pages, you can define the pattern here
    return `${basePath}/${pageNumber}`;
  };

  const renderPageNumbers = () => {
    const pages = [];
        
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <Link
          key={i}
          to={getPagePath(i)}
          className={`${Styles.pageButton} ${currentPage === i ? Styles.active : ''}`}
        >
          {i}
        </Link>
      );
    }
        
    return pages;
  };

  const isOnScoreboard = currentPath === `/fitnes-report-preview-detailed/${clientId}`;
     
  // Simple logic: if on scoreboard, show Previous, otherwise show Next
  const navButton = {
    to: isOnScoreboard ? `/fitnes-report-preview-summary/${clientId}` : `/fitnes-report-preview-detailed/${clientId}`,
    text: isOnScoreboard ? '< Previous' : 'Next >',
    show: true,
    isPrevious: isOnScoreboard
  };

  return (
    <div className={Styles.pagination}>
      {/* Unified Button Group */}
      <div className={Styles.buttonGroup}>
        {/* Page Numbers */}
        {renderPageNumbers()}
                
        {/* Dynamic Navigation Button */}
        {showNext && navButton.show && (
          <Link 
            to={navButton.to}
            className={Styles.nextButton}
          >
            <span className={Styles.buttonText}>{navButton.text}</span>
                   
          </Link>
        )}
      </div>
    </div>
  );
};

export default Reportbutton;